import { Block, EmailOutlined, MessageOutlined, PhoneOutlined } from "@mui/icons-material";
export const ContactType = {
    NONE: "NONE",
    CALL: "CALL",
    TEXT: "TEXT",
    EMAIL: "EMAIL"
};
export const ContactTypeIcon = {
    [ContactType.NONE]: Block,
    [ContactType.CALL]: PhoneOutlined,
    [ContactType.TEXT]: MessageOutlined,
    [ContactType.EMAIL]: EmailOutlined
};
// Used for components that require data (value and label)
// This only shows the icon
export const ContactTypeOptions = Object.values(ContactType).map((type) => ({
    label: ContactTypeIcon[type],
    value: type
}));
